import React from 'react'
import { SanityKeyTermsBlock } from '../../../../../types/generated/graphql-types'
import { sanityKeyTermsBlockToKeyTermsProps } from '../../../../mapping/KeyTermsBlockMapping'
import { BlockWithId } from '../../../../utilities/blockId'
import { KeyTermsBlock } from '../../../blocks/KeyTermsBlock'

export type KeyTermsBlockSerializerProps = SanityKeyTermsBlock & BlockWithId

export const KeyTermsBlockSerializer = ({
  id,
  ...props
}: KeyTermsBlockSerializerProps) => (
  <KeyTermsBlock {...sanityKeyTermsBlockToKeyTermsProps(props)} id={id} />
)
